/**
 * Featured Testimonials Section with Splide
 * - Slider enabled on mobile (all cases)
 * - Slider can be toggled on/off for desktop via settings (requires 4+ testimonials)
 * - Grid layout on desktop otherwise
 */

window.initFeaturedTestimonialsSlider = function (container) {
  const slider = container.querySelector('.featured-testimonials__slider');

  if (!slider || typeof Splide === 'undefined') return null;

  const blockCount = parseInt(container.dataset.blockCount || '0', 10);
  const enableSliderDesktop = container.dataset.enableSliderDesktop === 'true';
  let splideInstance = null;

  const shouldEnableSlider = () => {
    const isMobile = window.innerWidth < 1100;
    const hasEnoughBlocks = blockCount > 3;
    return isMobile || (enableSliderDesktop && hasEnoughBlocks);
  };

  // Initialize slider (always mounted, but may be disabled)
  splideInstance = window.SplideUtils.initSplideWithControls(
    slider,
    container,
    {
      perPage: 3,
      perMove: 1,
      gap: '24px',
      arrows: false,
      pagination: false,
      rewind: true,
      drag: shouldEnableSlider(), // Conditionally enable drag
      breakpoints: {
        1099: { 
          perPage: 2, 
          gap: '24px',
          padding: { right: '48px'},
          drag: true, // Always enabled on mobile
        },
        600: { 
          perPage: 1, 
          gap: '16px',
          padding: { right: '48px'},
          drag: true, // Always enabled on mobile
        }
      },
      i18n: {
        prev: 'Previous testimonial',
        next: 'Next testimonial',
        first: 'Go to first testimonial',
        last: 'Go to last testimonial',
        slideX: 'Go to testimonial %s',
        pageX: 'Go to page %s',
        play: 'Start autoplay',
        pause: 'Pause autoplay',
        carousel: 'Customer testimonials carousel',
        select: 'Select a testimonial to read',
        slide: 'testimonial',
        slideLabel: '%s of %s',
      }
    },
    {
      customArrows: true,
      scrollbar: true,
      tabindex: true
    }
  );

  // Add screen reader announcements for slide changes
  const announcer = container.querySelector('[data-slide-announcer]');
  if (announcer && splideInstance) {
    splideInstance.on('moved', (newIndex) => {
      const totalSlides = splideInstance.length;
      // Get translation from data attribute or use fallback
      const template = container.dataset.slideAnnouncementTemplate || 'Testimonial {{ current }} of {{ total }}';
      const announcement = template
        .replace('{{ current }}', newIndex + 1)
        .replace('{{ total }}', totalSlides);
      announcer.textContent = announcement;
    });
  }

  // Update slider state based on conditions
  const updateSlider = () => {
    if (!splideInstance) return;

    const shouldEnable = shouldEnableSlider();

    if (shouldEnable) {
      container.classList.add('slider-active');
      // Enable drag on desktop
      splideInstance.options.drag = true;
      splideInstance.refresh();
    } else {
      container.classList.remove('slider-active');
      // Disable drag on desktop when the grid layout is used
      splideInstance.options.drag = false;
      // Go to first slide when disabling
      splideInstance.go(0);
      splideInstance.refresh();
    }
  };

  // Initial setup
  updateSlider();

  // Handle resize
  let resizeTimeout;
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateSlider, 250);
  };
  window.addEventListener('resize', handleResize);

  // Return destroy function for cleanup
  return {
    destroy: () => {
      window.removeEventListener('resize', handleResize);
      if (splideInstance) splideInstance.destroy();
    }
  };
};

// Setup theme editor events
if (typeof window.SplideUtils !== 'undefined') {
  window.SplideUtils.setupThemeEditorEvents(
    'FeaturedTestimonials-',
    '.featured-testimonials__slider',
    (sectionElement) => {
      const container = sectionElement.querySelector('[id^="FeaturedTestimonials-"]');
      if (container) {
        if (container.sliderInstance?.destroy) {
          container.sliderInstance.destroy();
        }
        container.sliderInstance = initFeaturedTestimonialsSlider(container);
      }
    }
  );
}
